import React from 'react';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
    Grid,
    GridColumn,
    LeftComponents,
} from '../../components/Layout';
import {
    Button,
    DataForm,
} from '../../components/Form';


import {
    Title,
    TextView,
    PanelBox,
} from '../../components/Display';
import { postData } from '../../Api';

export default function TaroffOrdersSetPeik(props) {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [modal, setModal] = useState(null);
    const allProps = { ...props, ...Object.fromEntries(searchParams.entries()) };
    const [formViewTextTitle, setFormViewTextTitle] = useState(null);
    const handleCancel = async () => {
        props.onDismiss ? props.onDismiss() : navigate(-1);
    };
    const handleSetPeik = async () => {
        await postData('/api/panel/page/taroff-orders-set-peik/save-data', {
            id: allProps['taroff-order-id'],
        });
        props.onDismiss ? props.onDismiss() : navigate(-1);
    };
    useEffect(() => {
        postData('/api/panel/page/taroff-orders-set-peik/form-data', {
            id: allProps['taroff-order-id'],
        }).then((response) => {});
    }, []);
    return (
        <PanelBox>
            <DataForm>
                <Title>تغییر وضعیت</Title>
                <Grid>
                    <GridColumn width={12}>
                        <TextView>انتقال به وضعیت ارسال شده و پیک «</TextView>
                        <TextView>{formViewTextTitle}</TextView>
                        <TextView>» مورد تایید است ؟</TextView>
                    </GridColumn>
                </Grid>
                <LeftComponents>
                                    <Button onClick={handleCancel}>انصراف</Button>
                <Button onClick={handleSetPeik}>ذخیره و ارسال شده</Button>
                </LeftComponents>
            </DataForm>
            {modal && modal}
        </PanelBox>
    );
}
